// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__12yHL","actionsCol":"EnrolledClinics_actionsCol__2_70k"};